// src/hooks/useDynamicMeta.js
import { useEffect } from 'react';

export default function useDynamicMeta({ title, description, canonicalUrl, image }) {
  useEffect(() => {
    // 1. Title
    document.title = title;

    // 2. Description
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.setAttribute('name', 'description');
      document.head.appendChild(metaDesc);
    }
    metaDesc.setAttribute('content', description);

    // 3. Canonical Link
    let linkCanon = document.querySelector("link[rel='canonical']");
    if (!linkCanon) {
      linkCanon = document.createElement('link');
      linkCanon.setAttribute('rel', 'canonical');
      document.head.appendChild(linkCanon);
    }
    linkCanon.setAttribute('href', canonicalUrl);

    // 4. Open Graph Tags
    const ogTags = [
      { prop: 'og:title', content: title },
      { prop: 'og:description', content: description },
      { prop: 'og:url', content: canonicalUrl },
      { prop: 'og:image', content: image },
    ];
    ogTags.forEach(({ prop, content }) => {
      let tag = document.querySelector(`meta[property='${prop}']`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('property', prop);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    });

    // 5. Twitter Card Tags
    const twitterTags = [
      { name: 'twitter:title', content: title },
      { name: 'twitter:description', content: description },
      { name: 'twitter:image', content: image },
    ];
    twitterTags.forEach(({ name, content }) => {
      let tag = document.querySelector(`meta[name='${name}']`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('name', name);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    });
  }, [title, description, canonicalUrl, image]);
}
